import { MdDashboard } from "react-icons/md";
import { FaRobot, FaUsers, FaAddressBook } from "react-icons/fa";

export const sidebarItems = [
  {
    id: 1,
    label: "Dashboard",
    icon: <MdDashboard size={20} />,
    module: "dashboard",
    url: "/admin/dashboard",
    roles: ["admin", "editor", "viewer"],
  },
  {
    id: 2,
    label: "Bots",
    icon: <FaRobot size={20} />,
    module: "bots",
    url: "/admin/bots",
    roles: ["admin", "editor", "viewer"],
  },
  {
    id: 3,
    label: "Users",
    icon: <FaUsers size={20} />,
    module: "users",
    url: "/admin/users",
    roles: ["admin"],
  },
  {
    id: 4,
    label: "Leads",
    icon: <FaAddressBook size={20} />,
    module: "leads",
    url: "/admin/leads",
    roles: ["admin", "editor", "viewer"],
  },
];
